module.exports = __webpack_public_path__ + "img/schools.b5c6e2e0.png";